import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planQueryKeys } from '../constants'

export const useGetPlanFolderDetailsQuery = (folderId, options) => {
  const handleQuery = async () => {
    const config = {
      method: 'get'
    }
    const { data } = await api(`/api/v2/planFolders/${folderId}`, config)

    return data
  }

  return useQuery({
    queryKey: [planQueryKeys.GET_PLAN_FOLDER_DETAILS, folderId],
    queryFn: handleQuery,
    enabled: !!folderId,
    retry: 0,
    ...options
  })
}
